module.exports = __webpack_public_path__ + "static/C2020_ISARC_abs-d28c6d2324691b0f5123e915df7afcc2.gif";